import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

export interface CartlinesUpdateShipParameter extends ApiParameter {
    orderNumber: string;
    cartLines: CartLineModel[];
}

const serviceProductValidateData = "/api/v1/customvalidatecartline";

export function updateCartlineShippingDate(parameter: CartlinesUpdateShipParameter) {
    return post<any>(`${serviceProductValidateData}/updateshippingdate/${parameter.orderNumber}`, parameter.cartLines);
}
